
import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const Home = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const PGAAlberta = lazy(() => import("../pages/pga-alberta/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pga-alberta",
    element: <PGAAlberta />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
